/**
 * @module Filters
 * @description Some handy filters
 */

/**
 * @function stringify
 * @description Filter for Tagular Payload Object
 */
export const stringify = ( str ) => JSON.stringify( str );
